<template>
    <div>
        <motonet-header :class="{
                    'ml-n3': $vuetify.display.mdAndUp
                }">
            <h3 class="text-h5 font-weight-bold">{{$t('eshop::register.need_help')}}</h3>
        </motonet-header>
        <div class="pl-7 pt-10 mb-2">
            <div class="d-flex ga-5">
                <div>
                    <v-avatar size="64">
                        <v-img :src="needHelpImage[0]" position="0 8px" class="bg-grey-lighten-3"></v-img>
                    </v-avatar>
                    <v-avatar size="64" class="ml-n4 c-border">
                        <v-img :src="needHelpImage[1]" position="0 8px" class="bg-grey-lighten-3"></v-img>
                    </v-avatar>
                </div>
                <div>
                    <div class="d-flex align-center ga-3">
                        <v-icon color="orange" :size="24" :icon="mdiPhoneOutline"></v-icon>
                        <div>
                            <p class="text-body-1 font-weight-bold">{{ $t('app-bar.customer_service_phone') }}</p>
                            <p class="text-tiny-link text-grey-lighten-1">{{ $t('app-footer.contact_hours') }}</p>
                        </div>
                    </div>
                    <v-btn
                        block
                        :height="40"
                        color="orange"
                        variant="flat"
                        @click="contactModalActive = true"
                        class="mt-4"
                    >
                        <p class="text-white text-tiny-link font-weight-bold">{{$t('eshop::register.ask')}}</p>
                    </v-btn>
                </div>
            </div>
        </div>
        <contact-form-modal v-model="contactModalActive" :email="email"></contact-form-modal>
    </div>
</template>

<script setup>
import {mdiPhoneOutline} from "@mdi/js";
import MotonetHeader from "./MotonetHeader.vue";
import ContactFormModal from "./ContactFormModal.vue";
import { computed, ref, watch } from 'vue';
import { usePage } from '@inertiajs/vue3';
const props = defineProps({
    email: String
})

const needHelpImage = computed(
    () => {
        const needHelp = usePage().props.needHelp;
        return needHelp.map((item) => {
            return item.person?.main_image?.url;
        });
    }
);

const contactModalActive = ref(false);
</script>

<style scoped lang="scss">
.v-avatar{
    outline: 4px solid white;
}
</style>
